import React, { useRef } from 'react';
import Nav from '../components/Nav';
import HeroComparison from '../components/HeroComparison';
import Announcement from '../components/Announcement';
import WhatToExpect from '../components/WhatToExpect';
import Rebrand from '../components/Rebrand';
import PressRelease from '../components/PressRelease';
import FooterCta from '../components/FooterCta';

export default function Home() {
  const emailRef = useRef(null);

  const scrollToEmail = () => {
    if (emailRef.current) {
      emailRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => emailRef.current && emailRef.current.focus(), 500);
    }
  };

  return (
    <div className="relative min-h-screen bg-[#F5F2EC] text-neutral-900 overflow-hidden">
      <Nav onJoin={scrollToEmail} />

      {/* Hero */}
      <section className="relative pt-32 md:pt-40 pb-20 md:pb-28">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14">
          <HeroComparison />
          <Announcement inputRef={emailRef} />
        </div>

        {/* subtle decorative gradient (light, per guideline) */}
        <div
          className="pointer-events-none absolute -top-24 -right-24 w-[520px] h-[520px] rounded-full opacity-40"
          style={{
            background:
              'radial-gradient(circle at center, rgba(234,88,12,0.18) 0%, rgba(234,88,12,0) 60%)',
          }}
        />
      </section>

      <WhatToExpect />
      <Rebrand />
      <PressRelease />
      <FooterCta />
    </div>
  );
}
